module.exports = __webpack_public_path__ + "img/w2.52a437c1.png";